import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
function splitTitle(title: string) {
  const idx = title.indexOf(' (');
  if (idx === -1) return {
    main: title,
    sub: ''
  };
  return {
    main: title.slice(0, idx),
    sub: title.slice(idx + 1)
  };
}
export function Volumes() {
  return <section aria-label="System contents" className="bg-ice text-obsidian" data-id="element-284" data-mp="1zvb3o7gtq0fz">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-20" style={{
      paddingTop: "23px",
      paddingBottom: "26px"
    }} data-id="element-285" data-mp="1zt8f7rvbkfdd">
        <div className="text-center" data-id="element-286" data-mp="1qumzs5l59ggt">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-crimson" data-id="element-287" data-mp="1qtlbgzf4axh5">
            THE 100+ AI PROMPTS FOR FIREFIGHTERS: THE SYSTEM
          </p>
          <h2 className="mt-3 font-display text-[28px] font-extrabold tracking-tight text-obsidian sm:text-4xl" data-id="element-288" data-mp="ffhinwk9nfdo">
            📚 The 6-Volume Fire Service Vault
          </h2>
          <ul className="mx-auto mt-6 flex max-w-3xl flex-wrap justify-center gap-2" data-id="element-289" data-mp="kc7ycis5s8yk">
            {pillars.map(p => <li key={p} className="inline-flex items-center gap-1.5 rounded-full border border-mist bg-white px-3 py-1 text-xs font-semibold text-graphite" data-id="element-290" data-mp="3o9zvdy2igojr">
                <span className="h-1.5 w-1.5 rounded-full bg-rescue" aria-hidden="true" data-id="element-291" data-mp="21q5m0ooqitc" />
                {p}
              </li>)}
          </ul>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-292" data-mp="b1daiwgmi6r5">
          {volumes.map((t, i) => {
          const {
            main,
            sub
          } = splitTitle(t.title);
          return <motion.article key={t.n} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.3,
            delay: i % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-2xl border border-mist bg-white p-6 shadow-[0_1px_2px_rgba(16,19,23,0.04)]" data-id="element-293" data-mp="60pj49ohfnwe" data-mpi={i}>
                <div className="flex items-center gap-3" data-id="element-294" data-mp="wuinle04pga8">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-obsidian font-display text-base font-extrabold text-ice" data-id="element-295" data-mp="wrwgtgl2b4t2">
                    {String(t.n).padStart(2, '0')}
                  </span>
                  <span className="h-px flex-1 bg-mist" aria-hidden="true" data-id="element-296" data-mp="1bj5g6hero4je" />
                  <span className="h-1.5 w-1.5 rounded-full bg-crimson" aria-hidden="true" data-id="element-297" data-mp="1fk8sitxlvifv" />
                </div>
                <h3 className="mt-5 font-display text-[17px] font-extrabold leading-snug text-obsidian" data-id="element-298" data-mp="1kish723l38bx">{main}</h3>
                {sub && <p className="mt-1 text-xs font-semibold uppercase tracking-[0.1em] text-rescue-deep" data-id="element-299" data-mp="1pjg7tmnwhn5m">{sub}</p>}
                <p className="mt-3 text-sm leading-relaxed text-graphite" data-id="element-300" data-mp="1ug6nw9zpgir1">{t.desc}</p>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 rounded-2xl bg-obsidian p-6 sm:p-8" data-id="element-301" data-mp="3rc4bty8dcemg">
          <p className="text-center font-display text-lg font-extrabold text-ice sm:text-xl" data-id="element-302" data-mp="409l2billui">✅ Every Volume includes:</p>
          <ul className="mx-auto mt-6 grid max-w-3xl gap-4 sm:grid-cols-2" data-id="element-303" data-mp="2dfum9wxgthrc">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-ice/85" data-id="element-304" data-mp="28kx86blbwi7l">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-crimson" data-id="element-305" data-mp="24j244zc0jqq4">
                  <CheckIcon className="h-3 w-3 text-ice" strokeWidth={3.5} aria-hidden="true" data-id="element-306" data-mp="2wccba6kxj3jw" />
                </span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}